module.exports = __webpack_public_path__ + "img/9788959522200.5ab3444f.jpg";